export const countOrderItemsPrice = (order) =>
	order.order_items.reduce(
		(prevItem, nextItem) => prevItem + nextItem.price,
		0,
	);
